import React, { useRef } from 'react'
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import { useEffect } from 'react';
import "../styles/website.css"
import { Link, useNavigate } from 'react-router-dom';
import FAQ from '../components/Faqs';
import testimonial from "../assets/img/testimonial/d3.jpg"
import testimonial1 from "../assets/img/testimonial/d1.jpg"
import testimonial2 from "../assets/img/testimonial/d2.jpg"
import testimonial3 from "../assets/img/testimonial/d.jpg"
import { RiDoubleQuotesL } from "react-icons/ri";
import { RiDoubleQuotesR } from "react-icons/ri";
import { GoDash } from "react-icons/go";
 import heroImg from "../assets/img/digitalMarketing/dm7.jpg"
import "../styles/digitalMarketing.css"
import { IoIosArrowRoundDown } from "react-icons/io";
import servicesImg from "../assets/img/digitalMarketing/media.jpg"
import ServicesCards from '../components/ServicesCards';
import CaseStudyGallery from '../components/CaseStudyGallery';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import DigitalMarketingFAQs from '../components/DigitalMarketingFAQS';

const DigitalMarketing = () => {

 
  

    const navigate = useNavigate();
  
  
  const handleContactBtn = () => {
    navigate("/get-in-touch")
  }

       const servicesRef = useRef(null);
          
       useEffect (() => {
        const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
         const scrollReveal = () => {
            for (let i = 0; i < revealElements.length; i++) {
             const elementIsInScreen =
            revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
          
          if (elementIsInScreen) {
           revealElements[i].classList.add("revealed");
           } else {
              revealElements[i].classList.remove("revealed");
               }
            }
           };
          
           window.addEventListener("scroll", scrollReveal);
              scrollReveal(); // Initial check
          
              return () => {
                window.removeEventListener("scroll", scrollReveal);
              };
            }, []);
  

  return (
    <>
<section className="website-wrapper digital-marketing" ref={servicesRef}>
    
 <Nav/>

<section className="hero">
  <div className="hero-content dm__hero-content">
    <span className="hero-subtitle">Digital Marketing</span>
<h1>
  Accelerating <em>Start-Up</em> and <em>Scale-Up</em> Success with Proven Marketing Solutions
</h1>

    <p>
      We build, optimize, and scale marketing engines that generate pipeline and improve marketing ROI.
    </p>
    <a href="#about" className="hero-discover">
      Discover more <span className="arrow"><IoIosArrowRoundDown /></span>
    </a>
  </div>
  <div className="hero-image">
    <img src={heroImg} alt="Leaf illustration" />
  </div>
</section>


  <section className="about" id="about">
    <div className="corners">
      <div className="corner-1"></div>
      <div className="corner-2"></div>
    </div>    
     
   <div className="about__content">

    <h1 data-reveal>What you can expect from us: </h1>
<p data-reveal>
  We deliver an integrated, data-led approach to marketing, offering full product marketing services that combine cutting-edge performance strategies with world-class creative production. Our focus is on delivering measurable results, whether we’re working with start-ups, scale-ups, or established brands, across industries and borders.
</p>

  

   <div className="about__content-2">
    <div className="qoute__container">
    
      <p data-reveal="left"> 
     We don’t follow trends, we set them. By combining deep market insight,
        bold creative thinking, and measurable performance strategies.
       
      </p>
     </div>

              <div className="community-badge" data-reveal="right">
          <svg viewBox="0 0 200 200" className="badge-svg">
            <defs>
              <path
                id="circlePath"
                d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
              />
            </defs>
            <text fontSize="19" fill="#fff">
              <textPath href="#circlePath" startOffset="0%">
            • STRATEGY • CREATIVITY • PERFORMANCE • GROWTH
              </textPath>
            </text>
          </svg>
          <div className="badge-star">★</div>
        </div>
   </div>
   </div>

   

       <div className="corners__bottom">
      <div className="corner__bottom-1"></div>
      <div className="corner__bottom-2"></div>
    </div>
</section>

  <section className="digital__marketing-services ">
   <div className='services__top-col'>
    <span data-reveal>Our Services</span>
      <div className='services-content'>
        <h3 data-reveal>
         Level up your marketing,<br></br> improve<em> marketing ROI </em>
        </h3>
        <p data-reveal>
          Better  marketing leads to better marketing ROI. At Roarz Kreatives, we help you level up your complete marketing engine. From strategy to content, advertising, analytics and insights.
        </p>
      </div>
   </div>
    <div className='services__bottom-col'>
    <div className='services-img' data-reveal="left">
      <img src={servicesImg} alt="services-img"/>
    </div>
    <ServicesCards/>
    </div>
  </section>

   

  <CaseStudyGallery/>
  

   <DigitalMarketingFAQs/>




</section>

<section className="client-testimonials" >
  <h3>
    What our clients have said <br />
    <span>about our work</span>
  </h3>

  <div className="testimonial-cards" >
    {/* Retail Business */}
    <div className="testimonial-card">
      <p className="quote">
        “Our social media presence skyrocketed within months. Engagement grew
        4x, and we now get consistent leads directly from Instagram and
        Facebook campaigns.”
      </p>
      <div className="client-info">
        <img
          src={testimonial}
          alt="Jane Njeri"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Jane Wanjiku</p>
          <p className="client-title">Founder — Urban Chic Boutique, Nairobi</p>
        </div>
      </div>
    </div>

    {/* Real Estate */}
    <div className="testimonial-card" >
      <p className="quote">
        “Thanks to their Google Ads and SEO strategies, we now receive quality
        inquiries every week. Digital marketing has become our biggest driver of
        sales in real estate.”
      </p>
      <div className="client-info">
        <img
          src={testimonial1}
          alt="Peter Kamau"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Peter Abiola</p>
          <p className="client-title">Director — PrimeHomes Realty</p>
        </div>
      </div>
    </div>

    {/* E-commerce */}
    <div className="testimonial-card">
      <p className="quote">
        “Their campaigns doubled our online sales in just 3 months. The team
        understands e-commerce deeply and knows how to convert clicks into
        customers.”
      </p>
      <div className="client-info">
        <img
          src={testimonial2}
          alt="Aisha Mohamed"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Tracy Mwende</p>
          <p className="client-title">Co-founder — Swahili Crafts</p>
        </div>
      </div>
    </div>

    {/* Hospitality */}
    <div className="testimonial-card">
      <p className="quote">
        “Our hotel bookings went up significantly after launching targeted
        Facebook and Google campaigns. We now rely on their marketing strategies
        to fill our rooms year-round.”
      </p>
      <div className="client-info">
        <img
          src={testimonial3}
          alt="David Ochieng"
          className="client-avatar"
        />
        <div>
          <p className="client-name">David Ochieng</p>
          <p className="client-title">General Manager — Coastline Resort</p>
        </div>
      </div>
    </div>
  </div>
</section>



<section className="booking-wrapper">
  <div className="booking-content">
    <h3>Let's get to work</h3>
    <p>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
    <button className="get-started-btn" onClick={handleContactBtn}>
      Get Started <span className="plus-icon">+</span>
    </button>
  </div>
   

 
</section>

    <Footer/>
</>

  )
}

export default DigitalMarketing